module.exports = __webpack_public_path__ + "img/album20_06.1cbd5b84.jpg";